import LoadingSpinner from 'ui/LoadingSpinner';
import PageLayoutSectionView from '../../PageSectionLayout.View';

type BrandOverviewPlanProps = {
  plan: React.ReactNode;
  loading?: boolean;
};
const BrandOverviewPlanView = ({ plan, loading }: BrandOverviewPlanProps) => {
  let billingSections = [
    {
      label: 'Current plan',
      content: loading ? <LoadingSpinner /> : plan
    }
    // {
    //   label: 'Previous plan',
    //   content: '-', // TODO(Jenky): we're missing this data
    // },
    // TODO(Jenky): After shopify billing redo, temporarily removing this for the time being until we settle on logic for next billing date
    // {
    //   label: nextBillingDateLabel,
    //   content: nextBillingDate,
    // },
  ];

  // if loading, just leave the upper (current plan) section
  if (loading) {
    billingSections = billingSections.slice(0, 1);
  }

  // remove empty content sections
  billingSections = billingSections.filter(section => Boolean(section.content));

  return <PageLayoutSectionView sections={billingSections} />;
};

export default BrandOverviewPlanView;
